import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(['cursor-pointer', 'q-my-none', 'q-pt-xs'])
}
const _hoisted_2 = { class: "justify-left full-width" }
const _hoisted_3 = {
  class: "items-center q-mr-sm q-my-auto",
  style: {"word-wrap":"keep-all"}
}
const _hoisted_4 = {
  key: 1,
  class: "field-group"
}
const _hoisted_5 = {
  class: "flex items-end",
  style: {"flex-wrap":"nowrap"}
}
const _hoisted_6 = { class: "row justify-between q-mx-sm q-py-none no-wrap minw-selector" }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = {
  key: 0,
  class: "row justify-between full-width left-panel"
}
const _hoisted_9 = { class: "col-10" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row justify-between q-mx-sm q-py-none no-wrap minw-selector" }
const _hoisted_12 = {
  key: 7,
  style: {"word-wrap":"break-word"},
  class: "q-mt-xs text-blue"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_selector_popup = _resolveComponent("selector-popup")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_tag_selector = _resolveComponent("tag-selector")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_recursive_selector = _resolveComponent("recursive-selector")!
  const _component_multi_edit_line = _resolveComponent("multi-edit-line")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_card, {
    onKeydown: _ctx.windowKeyDown,
    style: 'max-width: 250px; min-width: 250px;'
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "q-py-xs q-pr-xs row" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([
          '',
          { 'text-grey-8': _ctx.isPromtDialog },
          { 'text-subtitle2': !_ctx.isPromtDialog },
        ]),
            style: {"max-width":"calc(100% - 30px)"}
          }, _toDisplayString(_ctx.isPromtDialog ? _ctx.msgText : _ctx.headerText), 3),
          _createVNode(_component_q_space),
          _withDirectives(_createVNode(_component_q_btn, {
            size: "sm",
            icon: "close",
            class: "q-my-none unset-items-center",
            flat: "",
            round: "",
            dense: ""
          }, null, 512), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      (!_ctx.isPromtDialog)
        ? (_openBlock(), _createBlock(_component_q_card_section, {
            key: 0,
            class: "scroll"
          }, {
            default: _withCtx(() => [
              (_ctx.modelType === 5 && _ctx.parameterMode === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("add_part")) + " " + _toDisplayString(_ctx.totalElements) + " " + _toDisplayString(_ctx.$t("to_list_part")) + ": ", 1),
                      _createElementVNode("div", {
                        ref: "listTriggerEl",
                        class: _normalizeClass(["items-center", [
              'cursor-pointer',
              { 'text-grey-8': !_ctx.listModel?.Entity?.Name },
            ]]),
                        style: {"word-wrap":"break-word"}
                      }, [
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.listMenuModel = !_ctx.listMenuModel)),
                          class: "q-mt-sm"
                        }, _toDisplayString(_ctx.listModel?.Entity?.Name || _ctx.$t("not_selected_label")), 1)
                      ], 2),
                      _createVNode(_component_selector_popup, {
                        visible: _ctx.listMenuModel,
                        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listMenuModel) = $event)),
                        "trigger-el": _ctx.$refs.listTriggerEl,
                        "default-width": 300
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_aux_selector, {
                            ref: "aux_selector",
                            "filter-model-value": _ctx.aux_filter_string,
                            "onUpdate:filterModelValue": _cache[1] || (_cache[1] = (arg) => { _ctx.aux_filter_string = arg; }),
                            "model-value": [],
                            "show-search-header": true,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = (arg) => { _ctx.onUpdateListModel(arg); }),
                            onInputValue: _cache[3] || (_cache[3] = (val) => { _ctx.onUpdateListModelNew(val); }),
                            "allow-free-input": true,
                            "allow-multiple": true,
                            "model-type": 17,
                            "limit-height-to-container": true,
                            "exclude-id": _ctx.srcElement.elType == 6 ? _ctx.srcElement.Id : 0,
                            "preferred-segment": _ctx.srcElement.DestType,
                            onSelectorClosed: _ctx.hideListMenu
                          }, null, 8, ["filter-model-value", "exclude-id", "preferred-segment", "onSelectorClosed"])
                        ]),
                        _: 1
                      }, 8, ["visible", "trigger-el"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.modelType === 6)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_q_select, {
                      flat: "",
                      modelValue: _ctx.commentChangeType,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.commentChangeType) = $event)),
                      class: "thin-input q-mb-xs q-mr-xs",
                      "fill-input": "",
                      "bottom-slots": false,
                      dense: "",
                      outlined: "",
                      "label-slot": false,
                      "hide-bottom-space": "",
                      disable: _ctx.parameterMode === 2,
                      "dropdown-icon": "expand_more",
                      "option-value": "Id",
                      "option-label": "Name",
                      "input-debounce": "500",
                      ref: 'comment_type_select',
                      options: _ctx.changeCommentOptions
                    }, null, 8, ["modelValue", "disable", "options"]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_native_input, {
                        ref: "comment_field",
                        style: {"width":"-webkit-fill-available"},
                        "show-border": true,
                        "model-value": _ctx.innerNote,
                        "onUpdate:caretPosition": _ctx.onCaretPositionChange,
                        onClick: _ctx.onNativeInputClick,
                        onBlur: _ctx.onCommentBlur,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = 
              (newname) => {
                _ctx.innerNote = newname;
              }
            ),
                        "edit-on-click": true
                      }, null, 8, ["model-value", "onUpdate:caretPosition", "onClick", "onBlur"]),
                      _createVNode(_component_q_btn, {
                        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                        dense: "",
                        flat: "",
                        color: "accent",
                        size: "11px",
                        icon: _ctx.templateIconName,
                        style: {"align-self":"start"},
                        class: "q-pa-none q-ml-sm"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_menu, {
                            "max-height": "1300px",
                            ref: "comment_template_menu",
                            anchor: "center right",
                            self: "center left"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_aux_selector, {
                                "model-type": _ctx.parameterMode === 1 ? 24 : 25,
                                "input-index": 0,
                                "allow-multiple": false,
                                "allow-free-input": true,
                                onDeleteItem: _ctx.deleteCommentTemplate,
                                "onUpdate:caretPosition": _ctx.onCaretPositionChange,
                                modelValue: _ctx.comment_templates,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.comment_templates) = $event)),
                                onInputValue: _cache[8] || (_cache[8] = 
                  (val) => {
                    _ctx.addCommentTemplate(val);
                  }
                ),
                                onSelectorClosed: _cache[9] || (_cache[9] = ($event: any) => (
                  _ctx.$refs.comment_template_menu &&
                  _ctx.$refs.comment_template_menu.hide()
                ))
                              }, null, 8, ["model-type", "onDeleteItem", "onUpdate:caretPosition", "modelValue"])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      }, 8, ["icon"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.modelType === 1 && [1, 2].includes(_ctx.parameterMode))
                ? (_openBlock(), _createBlock(_component_q_select, {
                    key: 2,
                    label: _ctx.$t('tags_upcase'),
                    ref: "tags_field",
                    outlined: "",
                    modelValue: _ctx.tagsModel,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.tagsModel) = $event)),
                    "use-input": "",
                    "use-chips": "",
                    multiple: "",
                    autofocus: "",
                    "option-label": "Name",
                    "option-value": "Id",
                    onInputValue: _ctx.inputFilter,
                    onNewValue: _ctx.addTextTag,
                    "input-debounce": "100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_menu, {
                        fit: "",
                        "no-focus": "",
                        modelValue: _ctx.selectorModel,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectorModel) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_ctx.modelType === 1)
                            ? (_openBlock(), _createBlock(_component_tag_selector, {
                                key: 0,
                                filter_string: _ctx.filter_string,
                                modelValue: _ctx.tagsModel,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.tagsModel) = $event))
                              }, null, 8, ["filter_string", "modelValue"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label", "modelValue", "onInputValue", "onNewValue"]))
                : (_ctx.modelType === 1 && _ctx.parameterMode === 3)
                  ? (_openBlock(), _createBlock(_component_q_select, {
                      key: 3,
                      style: {"min-width":"150px"},
                      autogrow: "",
                      autofocus: "",
                      outlined: "",
                      color: "black",
                      "input-debounce": "500",
                      "fill-input": "",
                      modelValue: _ctx.tempTagStatus,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.tempTagStatus) = $event)),
                      "no-error-icon": "",
                      hint: _ctx.$t('status_label'),
                      options: _ctx.tagStatusOptions
                    }, null, 8, ["modelValue", "hint", "options"]))
                  : (_ctx.modelType === 15 && _ctx.parameterMode === 2)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 4,
                        class: "q-my-none q-pa-none text-left",
                        flat: "",
                        "no-caps": "",
                        align: "left",
                        size: "sm",
                        dense: "",
                        color: "grey-8",
                        label: _ctx.parameterModelStr,
                        "aria-label": _ctx.$t('select_parameter')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            delay: 1000,
                            anchor: "top middle",
                            self: "center middle"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("select_parameter")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_menu, {
                            fit: "",
                            style: {"overflow":"hidden"},
                            modelValue: _ctx.parameterSelectorModel,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.parameterSelectorModel) = $event)),
                            "auto-close": "",
                            onBeforeShow: _cache[22] || (_cache[22] = (e) => { _ctx.filter_string = '' })
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_q_input, {
                                  outlined: "",
                                  dense: "",
                                  ref: "panel_search_input",
                                  color: "white",
                                  class: "full-width thin-input q-my-auto",
                                  modelValue: _ctx.filter_string,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filter_string) = $event)),
                                  "hide-bottom-space": "",
                                  placeholder: _ctx.$t('search_label'),
                                  autofocus: "",
                                  debounce: "100",
                                  onKeydown: [
                                    _cache[16] || (_cache[16] = _withKeys(_withModifiers(($event: any) => (
                _ctx.$refs.rec_selector &&
                  (_ctx.$refs.rec_selector).trackArrowDown(1)
              ), ["exact","prevent"]), ["down"])),
                                    _cache[17] || (_cache[17] = _withKeys(_withModifiers(($event: any) => (
                _ctx.$refs.rec_selector &&
                  (_ctx.$refs.rec_selector).trackArrowUp(1)
              ), ["exact","prevent"]), ["up"]))
                                  ],
                                  onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (
                _ctx.$refs.rec_selector &&
                  (_ctx.$refs.rec_selector).selectCurrent()
              ), ["enter"]))
                                }, null, 8, ["modelValue", "placeholder"]),
                                _createVNode(_component_q_btn, {
                                  class: "q-my-sm q-px-none q-mr-none q-ml-lg",
                                  flat: "",
                                  dense: "",
                                  "aria-label": _ctx.$t('close_selector'),
                                  icon: "close",
                                  size: "md",
                                  onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.parameterSelectorModel = false), ["stop","prevent"]))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, { delay: 1000 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("close_menu")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["aria-label"])
                              ]),
                              _createVNode(_component_q_separator, { class: "q-my-none q-py-none" }),
                              _createVNode(_component_recursive_selector, {
                                style: {"max-height":"50vh","overflow":"auto"},
                                ref: "rec_selector",
                                elements: _ctx.parametersList,
                                "take-ids-only": true,
                                "show-records": true,
                                "allow-multiple": false,
                                "element-type": 9,
                                modelValue: _ctx.parametersModel,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.parametersModel) = $event)),
                                "hide-checkboxes": true,
                                "return-type": "chain",
                                "nested-key-name": "RecordFields",
                                "entity-inside-name": "Template",
                                "filter-out-list": [7],
                                "filter-string": _ctx.filter_string
                              }, null, 8, ["elements", "modelValue", "filter-string"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "aria-label"]))
                    : _createCommentVNode("", true),
              (_ctx.modelType === 15 && _ctx.parameterMode === 2 && _ctx.parameterContainer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_ctx.parameterContainer.IsList)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("list_param_values")), 1),
                          _createVNode(_component_q_btn, {
                            class: "q-my-none",
                            flat: "",
                            dense: "",
                            round: "",
                            icon: "add",
                            size: "sm",
                            color: "grey-8",
                            onClick: _ctx.addParamRow,
                            "aria-label": _ctx.$t('add_list_element')
                          }, null, 8, ["onClick", "aria-label"])
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paramRows, (param_row, param_index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'pr_' + param_index,
                        class: "row full-width"
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_multi_edit_line, {
                            class: "q-my-xs q-mr-xs",
                            modelValue: _ctx.paramRows[param_index],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.paramRows[param_index]) = $event),
                            "parameter-value-type": _ctx.parameterContainer.ValueType,
                            "parameter-set-value-type": 
                _ctx.parameterContainer.ValueSet
                  ? _ctx.parameterContainer.ValueSet.ValueType
                  : 0
              ,
                            "vset-type": _ctx.vsetType,
                            "vset-title": _ctx.vsetTitle,
                            vsetOptions: _ctx.vsetOptions
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "parameter-value-type", "parameter-set-value-type", "vset-type", "vset-title", "vsetOptions"])
                        ]),
                        (_ctx.parameterContainer.IsList)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              class: "q-my-none",
                              flat: "",
                              dense: "",
                              round: "",
                              icon: "close",
                              size: "sm",
                              color: "grey-8",
                              onClick: ($event: any) => (_ctx.deleteParamRow(param_index)),
                              "aria-label": _ctx.$t('delete_list_element'),
                              tabindex: "-1"
                            }, null, 8, ["onClick", "aria-label"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.modelType === 15 && [1, 3].includes(_ctx.parameterMode))
                ? (_openBlock(), _createBlock(_component_q_select, {
                    key: 6,
                    flat: "",
                    modelValue: _ctx.multipleParametersModel,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.multipleParametersModel) = $event)),
                    "fill-input": "",
                    multiple: "",
                    outlined: "",
                    dense: "",
                    "use-chips": "",
                    "option-label": "Name",
                    "option-value": "Id",
                    "input-debounce": "500",
                    label: _ctx.$t('select_parameters')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_menu, {
                        fit: "",
                        style: {"overflow":"hidden"},
                        modelValue: _ctx.parameterSelectorModel,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.parameterSelectorModel) = $event)),
                        onBeforeShow: _cache[30] || (_cache[30] = (e) => { _ctx.filter_string = '' })
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_q_input, {
                              outlined: "",
                              dense: "",
                              ref: "panel_search_input",
                              class: "full-width thin-input q-my-auto",
                              modelValue: _ctx.filter_string,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.filter_string) = $event)),
                              "hide-bottom-space": "",
                              placeholder: _ctx.$t('search_label'),
                              autofocus: "",
                              debounce: "100",
                              onKeydown: [
                                _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (
                _ctx.$refs.rec_selector &&
                  (_ctx.$refs.rec_selector).trackArrowDown(1)
              ), ["exact","prevent"]), ["down"])),
                                _cache[25] || (_cache[25] = _withKeys(_withModifiers(($event: any) => (
                _ctx.$refs.rec_selector &&
                  (_ctx.$refs.rec_selector).trackArrowUp(1)
              ), ["exact","prevent"]), ["up"]))
                              ],
                              onKeyup: _cache[26] || (_cache[26] = _withKeys(($event: any) => (
                _ctx.$refs.rec_selector &&
                  (_ctx.$refs.rec_selector).selectCurrent()
              ), ["enter"]))
                            }, null, 8, ["modelValue", "placeholder"]),
                            _createVNode(_component_q_btn, {
                              class: "q-my-sm q-px-none q-mr-none q-ml-lg",
                              flat: "",
                              dense: "",
                              "aria-label": _ctx.$t('close_selector'),
                              icon: "close",
                              size: "md",
                              onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.parameterSelectorModel = false), ["stop","prevent"]))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, { delay: 1000 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("close_menu")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["aria-label"])
                          ]),
                          _createVNode(_component_q_separator, { class: "q-my-none q-py-none" }),
                          _createVNode(_component_recursive_selector, {
                            style: {"max-height":"50vh","overflow":"auto"},
                            ref: "rec_selector",
                            elements: _ctx.parametersList,
                            "take-ids-only": true,
                            "show-records": false,
                            "allow-multiple": true,
                            "element-type": 9,
                            modelValue: _ctx.multipleParametersModelChains,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.multipleParametersModelChains) = $event)),
                            "hide-checkboxes": false,
                            "return-type": "chain",
                            "nested-key-name": "RecordFields",
                            "entity-inside-name": "Template",
                            "filter-string": _ctx.filter_string
                          }, null, 8, ["elements", "modelValue", "filter-string"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "label"]))
                : _createCommentVNode("", true),
              (_ctx.msgText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.msgText), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_card_actions, { align: "right" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_btn, {
            flat: "",
            size: "sm",
            label: _ctx.operation_passed ? _ctx.$t('close_label') : _ctx.$t('cancel'),
            ref: "cancelbtn",
            color: "dark"
          }, null, 8, ["label"]), [
            [_directive_close_popup]
          ]),
          (!_ctx.forbidden && !_ctx.operation_passed)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                flat: "",
                size: "sm",
                label: _ctx.check_passed ? _ctx.$t('continue') : _ctx.headerText,
                ref: "okbtn",
                color: "dark",
                autofocus: "",
                onClick: _ctx.performAction
              }, null, 8, ["label", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onKeydown"]))
}